module.exports = __webpack_public_path__ + "static/media/expand.8372761d.svg";